"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  emptyTip: '数据为空',
  search: '搜索',
  filter: '筛选',
  searchResult: '搜索结果',
  items: '条',
  reset: '返回列表',
  period: '。',
  semicolon: '；',
  colon: '：',
  selected: '已选择',
  cancelSelect: '取消选择',
  columnConfigHeader: '自定义列表',
  columnConfigTip: '清除缓存或更换浏览器，自定义列表失效。',
  columnConfigSelected: '选中'
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud-fe/react-components/lib/components/Table/locale/zh_CN.js
// module id = 1891
// module chunks = 6 7 17 18